module.exports = __webpack_public_path__ + "media/latire.c3df66ef.mp3";